import {TagIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasLabels, pluralize} from './activity-row-helpers'

export function LabelsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasLabels(summary)) return null

  const n = summary.labeled.count
  const label = `${n} label ${pluralize(n, 'change', 'changes')}`

  return <SidebarActivityRow icon={TagIcon} label={label} group="labels" expectedCount={n} />
}
